import type { HealthDto } from "./health.ts";

export const lateAfterMs = 3 * 60_000;
export const stoppedAfterMs = 15 * 60_000;

const worsening: readonly HealthDto["schedule"][] = ["ok", "atrasada", "parada"];

export function healthAt(health: HealthDto, now: number): HealthDto {
  if (health.lastBeatAt === undefined || health.schedule === "sem-agenda") return health;
  const age = now - Date.parse(health.lastBeatAt);
  const aged = age < lateAfterMs ? "ok" : age < stoppedAfterMs ? "atrasada" : "parada";
  return worsening.indexOf(aged) > worsening.indexOf(health.schedule) ? { ...health, schedule: aged } : health;
}
